export default function ContactSection() {
  return (
    <footer className="w-full bg-background-200 py-20 md:py-28">
      <div className="mx-auto max-w-[1440px] px-6 md:px-20 lg:px-[100px]">
        <div className="bg-background-50 rounded-[24px] px-8 md:px-14 lg:px-16 py-14 md:py-16">
          <div className="flex flex-col lg:flex-row gap-12 lg:gap-20">
            {/* Left Brand Block */}
            <div className="lg:w-[28%]">
              <div className="w-10 h-10 rounded-full bg-accent-500 flex items-center justify-center">
                <i className="ri-stack-line text-background-50 text-lg"></i>
              </div>
              <p className="font-body text-sm text-foreground-600 leading-relaxed mt-5 max-w-[260px]">
                A professional engineering team delivering modern digital software solutions with a
                focus on technical excellence and long-term quality.
              </p>
            </div>

            {/* Contact Columns */}
            <div className="flex-1 grid grid-cols-1 sm:grid-cols-3 gap-10 sm:gap-8">
              {/* Location */}
              <div>
                <h4 className="font-label text-xs font-semibold uppercase tracking-[0.06em] text-secondary-500">
                  Location
                </h4>
                <address className="mt-6 not-italic">
                  <p className="font-body text-sm text-foreground-700 leading-relaxed">
                    Pagegiu g. 15B-12
                  </p>
                  <p className="font-body text-sm text-foreground-700 leading-relaxed mt-1">
                    Kaunas, 48464
                  </p>
                  <p className="font-body text-sm text-foreground-700 leading-relaxed mt-1">
                    Lithuania
                  </p>
                </address>
              </div>

              {/* Phone */}
              <div>
                <h4 className="font-label text-xs font-semibold uppercase tracking-[0.06em] text-secondary-500">
                  Direct
                </h4>
                <p className="font-body text-sm text-foreground-700 leading-relaxed mt-6">
                  +370 66806311
                </p>
              </div>

              {/* Email */}
              <div>
                <h4 className="font-label text-xs font-semibold uppercase tracking-[0.06em] text-secondary-500">
                  Digital
                </h4>
                <p className="font-body text-sm text-foreground-700 leading-relaxed mt-6">
                  ceo@vytenistech.com
                </p>
              </div>
            </div>
          </div>

          {/* Bottom Divider */}
          <div className="mt-14 pt-8 border-t border-background-200/70">
            <p className="font-body text-xs text-foreground-500">
              &copy; {new Date().getFullYear()} All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}